import React from "react";
import PropTypes from "prop-types";
import Icon from "../../components/_default/Icon";

export default function LoginLayout({ children }) {
  return (
    <div className="c-login-wrapp">
      <div className="c-logo">
        <Icon icon="aurum-logo" size={280} height={65} color="#fff" />
      </div>
      {children}
    </div>
  );
}
LoginLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
